import React from "react"
import PropTypes from "prop-types"
import rehypeReact from "rehype-react"
import BlogOpportunityLink from "./BlogOpportunityLink"
import InternalLink from "./InternalLink"
import ExternalLink from "./ExternalLink"
import AboutBlurb from "./AboutBlurb"
import FeaturedButton from "./FeaturedButton"
import QuoteBox from "./QuoteBox"
import LearnMoreBox from "./LearnMoreBox"
import SignUpBox from "./SignUpBox"

const renderAst = new rehypeReact({
  createElement: React.createElement,
  components: {
    "blog-opportunity-link": BlogOpportunityLink,
    "internal-link": InternalLink,
    "external-link": ExternalLink,
    "about-blurb": AboutBlurb,
    "featured-button": FeaturedButton,
    "quote-box": QuoteBox,
    "learn-more-box": LearnMoreBox,
    "sign-up-box": SignUpBox,
  },
}).Compiler

export const HTMLContent = ({ content, className }) =>
  renderAst(content.htmlAst)

const Content = ({ content, className }) => (
  <div className={className}>{renderAst(content.htmlAst)}</div>
)

Content.propTypes = {
  content: PropTypes.object,
  className: PropTypes.string,
}

HTMLContent.propTypes = Content.propTypes

export default Content
